import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import logo from '../images/stihl-marker.png';

const ContactMap = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultZoom={19}
    defaultCenter={props.marker}
    defaultOptions={{ fullscreenControl: false, mapTypeControl: false }}
  >
    <Marker position={props.marker} icon={logo} />
  </GoogleMap>
)));

export default ContactMap;



// WEBPACK FOOTER //
// ./src/components/ContactMap.js